// extracted by mini-css-extract-plugin
export default {"backgroundSection":"BackgroundSection_backgroundSection__0Rbxu","container":"BackgroundSection_container__zcSYA","titleHome":"BackgroundSection_titleHome__ps8a4"};